import { RootState } from '..';

export const invoiceSelector = (state: RootState) => state.invoice;

export const invoicesListSelector = (state: RootState) => state.invoice.list;

export const invoicesPaginationSelector = (state: RootState) => state.invoice.pagination;

export const invoicesOptionsSelector = (state: RootState) => state.invoice.options;
